<script setup>
import dayjs from 'dayjs'
import { getI18n } from '@/plugins/i18n'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  conflicts: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const i18n = getI18n()
</script>

<template>
  <q-dialog
    :model-value="props.modelValue"
    persistent
    class="dialog-xxs"
    @update:model-value="value => emit('update:modelValue', value)"
  >
    <q-card>
      <q-card-section class="row items-center no-wrap">
        <q-avatar
          icon="mdi-alert"
          color="warning"
          text-color="white"
          size="md"
        />
        <span class="q-ml-sm text-subtitle1">{{ i18n.t('warning.eventConfirmedConflict') }}</span>
      </q-card-section>
      <q-card-section class="q-pt-none">
        <q-list dense>
          <q-item v-for="(conflict, idx) in props.conflicts" :key="idx" dense>
            <q-item-section>
              <q-item-label>{{ conflict.project }}</q-item-label>
              <q-item-label caption>
                {{ dayjs(conflict.start).format('DD/MM/YYYY HH:mm') }} – {{ dayjs(conflict.end).format('DD/MM/YYYY HH:mm') }}
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn v-close-popup flat :label="i18n.t('common.cancel')" />
        <q-btn
          color="negative"
          :label="i18n.t('common.removeConflictsAndProceed')"
          @click="emit('remove')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
